// import Swiper JS
import Swiper, { Autoplay, Pagination } from 'swiper';

// import Swiper styles
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", function(e) {
	let purchase_form = document.getElementById('jd-car-slider');

	//if the form exists on this page
	if(purchase_form) {
		Swiper.use([Autoplay, Pagination]);

		new Swiper('#jd-car-slider', {
			loop: true,
			autoplay: {
				delay: 5000
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 5,
			},
			breakpoints: {
				600: {
					pagination: {
						dynamicMainBullets: 10,
					}
				},
				1000: {
					pagination: {
						dynamicBullets: false,
					}
				}
			}
		});
	}
});